import { render, staticRenderFns } from "./MainLedgerPrintCard4.vue?vue&type=template&id=390c4c65&scoped=true"
import script from "./MainLedgerPrintCard4.vue?vue&type=script&lang=js"
export * from "./MainLedgerPrintCard4.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerPrintCard4.vue?vue&type=style&index=0&id=390c4c65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390c4c65",
  null
  
)

export default component.exports